// @ts-nocheck
import PropTypes from "prop-types";
import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useBalanceStore} from "../../../../../../../../../store/useBalance.store";
import useCreateTicket from "../../../../../../hooks/useCreateTicket";
import {isDrawPassed} from "../../../../../../utils/timeUtils";
import {processAgregarBetTerminal} from "../../../../utils/lottery.util";
import ConfirmTicketModal from "../../../ConfirmTicketModal";
import CustomNotification from "../../../CustomNotification";
import * as boardCls from "../_lotteryBoardCls";

const TerminalBoard = ({gameName, draws = []}) => {
  const {t} = useTranslation();
  const balance = useBalanceStore(state => state.getBalance);
  const {postCreateTicket, isPending, isSuccess, isError} = useCreateTicket();
  const navigate = useNavigate();

  const [selectedHours, setSelectedHours] = useState([]);
  const [numberInput, setNumberInput] = useState("");
  const [betAmount, setBetAmount] = useState("");
  const [ticketBets, setTicketBets] = useState([]);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);

  const scaledRef = useRef(null);
  const containerRef = useRef(null);

  const [processedDraws, setProcessedDraws] = useState([]);

  useEffect(() => {
    if (draws && draws.length > 0) {
      const processed = draws.map(draw => ({
        id: draw.id,
        time: draw.hora,
        name: draw.nombre,
        closeTime: draw.closeTime,
        isPassed: isDrawPassed(draw.hora, draw.closeTime),
      }));
      setProcessedDraws(processed);
    }
  }, [draws]);

  useEffect(() => {
    setSelectedHours([]);
    setNumberInput("");
    setBetAmount("");
    setTicketBets([]);
    setIsConfirmModalVisible(false);
  }, [gameName]);

  const handleHourClick = draw => {
    if (draw.isPassed) return;

    setSelectedHours(prev => {
      const isSelected = prev.includes(draw.time);
      if (isSelected) {
        return prev.filter(time => time !== draw.time);
      } else {
        return [...prev, draw.time];
      }
    });
  };

  const handleNumberInput = e => {
    const value = e.target.value;
    if (value.length <= 2 && /^\d*$/.test(value)) {
      setNumberInput(value);
    }
  };

  const handleAgregarClick = () => {
    const selectedDraws = processedDraws.filter(draw => selectedHours.includes(draw.time));

    const result = processAgregarBetTerminal(numberInput, betAmount, selectedDraws);
    if (!result.success) {
      CustomNotification.error(result.error);
      return;
    }

    function mergeBets(existingBets, newBets) {
      const merged = [...existingBets];
      newBets.forEach(newBet => {
        const idx = merged.findIndex(b => b.number === newBet.number && b.drawId === newBet.drawId);
        if (idx !== -1) {
          merged[idx] = {
            ...merged[idx],
            amount: Number(merged[idx].amount) + Number(newBet.amount),
          };
        } else {
          merged.push(newBet);
        }
      });
      return merged;
    }

    setTicketBets(prev => mergeBets(prev, result.bets));
  };

  const handleProcessTicket = () => {
    if (ticketBets.length === 0) {
      CustomNotification.warning("Debe agregar al menos una apuesta antes de comprar");
      return;
    }

    setIsConfirmModalVisible(true);
  };

  const handleConfirmPurchase = () => {
    const totalAmount = ticketBets.reduce((sum, bet) => sum + bet.amount, 0);
    if (balance < totalAmount) {
      CustomNotification.error(t("lotteryErrorBalance") || "Saldo insuficiente");
      return;
    }

    const betsByDraw = {};
    ticketBets.forEach(bet => {
      if (!betsByDraw[bet.drawId]) {
        betsByDraw[bet.drawId] = [];
      }
      const paddedNumber = String(bet.number).padStart(2, "0");
      betsByDraw[bet.drawId].push({
        numbers: [paddedNumber],
        amount: parseFloat(bet.amount),
        sign_id: null,
      });
    });

    const items = Object.keys(betsByDraw).map(drawId => ({
      draw_id: drawId,
      bets: betsByDraw[drawId],
    }));

    const payload = {
      currency: "VES",
      items,
    };

    postCreateTicket(payload);
  };

  const handleCloseConfirmModal = () => {
    setIsConfirmModalVisible(false);
    if (isSuccess) {
      setTicketBets([]);
      setNumberInput("");
      setBetAmount("");
      setSelectedHours([]);
    }
  };

  const handleCloseModalKeepBets = () => {
    setIsConfirmModalVisible(false);
  };

  const handleClearAll = () => {
    setNumberInput("");
    setSelectedHours([]);
    setBetAmount("");
    setTicketBets([]);
  };

  const handleDeleteBet = indexToDelete => {
    setTicketBets(prev => prev.filter((_, index) => index !== indexToDelete));
  };

  return (
    <div
      className={boardCls.boardContainerCls}
      ref={containerRef}
    >
      <div
        className={boardCls.scaledContentCls}
        ref={scaledRef}
      >
        <button
          type="button"
          className={boardCls.myTicketsButtonCls}
          onClick={() => navigate("/lottery/tickets")}
        >
          {t("lotteryMyTickets") || "Mis Tickets"}
        </button>
        <div className={boardCls.boardTitleCls}>{gameName}</div>

        <div className={boardCls.mainContentCls}>
          {/* Left Section - Hour Selection */}
          <div className={boardCls.leftSectionCls}>
            <div className={boardCls.sectionTitleCls}>HORARIO</div>
            <div className={boardCls.hoursGridCls}>
              {processedDraws.length === 0 ? (
                <div className={boardCls.noDrawsMessageCls}>No hay sorteos disponibles</div>
              ) : (
                processedDraws.map(draw => (
                  <button
                    key={draw.id}
                    type="button"
                    className={`${boardCls.hourButtonCls} ${selectedHours.includes(draw.time) ? boardCls.hourButtonSelectedCls : ""} ${
                      draw.isPassed ? boardCls.hourButtonDisabledCls : ""
                    }`}
                    onClick={() => handleHourClick(draw)}
                    disabled={draw.isPassed}
                    title={draw.isPassed ? "Este sorteo ya pasó" : draw.name}
                  >
                    {draw.time}
                  </button>
                ))
              )}
            </div>
          </div>

          {/* Center Section - Betting Controls */}
          <div className={boardCls.centerSectionCls}>
            <div className={boardCls.inputGroupCls}>
              <label className={boardCls.inputLabelCls}>
                NUMERO:
                <input
                  type="text"
                  className={boardCls.numberInputCls}
                  value={numberInput}
                  onChange={handleNumberInput}
                  maxLength={2}
                />
              </label>

              <label className={boardCls.inputLabelCls}>
                MONTO:
                <input
                  type="number"
                  className={boardCls.amountInputCls}
                  value={betAmount}
                  onChange={e => {
                    const value = e.target.value;
                    setBetAmount(value === "" ? "" : Math.max(0, Number(value)));
                  }}
                  min="0"
                />
              </label>
            </div>

            <div className={boardCls.betTypeContainerCls}>
              <button
                type="button"
                className={boardCls.betTypeButtonCls}
                onClick={handleAgregarClick}
              >
                AGREGAR
              </button>
            </div>
            <div className={boardCls.actionButtonsCls}>
              <button
                type="button"
                className={`${boardCls.actionButtonCls} ${boardCls.processButtonCls}`}
                onClick={handleProcessTicket}
              >
                COMPRAR TICKET
              </button>
              <button
                type="button"
                className={`${boardCls.actionButtonCls} ${boardCls.clearButtonCls}`}
                onClick={handleClearAll}
              >
                LIMPIAR
              </button>
            </div>
          </div>

          {/* Right Section - Ticket Summary */}
          <div className={boardCls.rightSectionCls}>
            <div className={boardCls.summaryContainerCls}>
              <div className={boardCls.summaryHeaderCls}>
                <div className={boardCls.summaryProgressCls} />
                <div className={boardCls.summaryHeaderRowCls}>
                  <div className={boardCls.summaryHeaderCellCls}>Horario</div>
                  <div className={boardCls.summaryHeaderCellCls}>Terminal</div>
                  <div className={boardCls.summaryHeaderCellCls}>Monto</div>
                  <div className={boardCls.summaryHeaderCellCls}></div>
                </div>
              </div>

              <div className={boardCls.summaryBodyCls}>
                {ticketBets.length === 0 ? (
                  <div className={boardCls.summaryRowCls}>
                    <div className={boardCls.summaryCellCls}>No hay apuestas</div>
                    <div className={boardCls.summaryCellCls}>-</div>
                    <div className={boardCls.summaryCellCls}>0</div>
                  </div>
                ) : (
                  <>
                    {ticketBets.map((bet, index) => (
                      <div
                        // biome-ignore lint/suspicious/noArrayIndexKey: same drawId+number can repeat across plays; index disambiguates
                        key={`${bet.drawId}-${bet.number}-${index}`}
                        className={boardCls.summaryRowCls}
                      >
                        <div className={boardCls.summaryCellCls}>{bet.drawName || bet.drawTime}</div>
                        <div className={boardCls.summaryCellCls}>{bet.number}</div>
                        <div className={boardCls.summaryCellCls}>{bet.amount}</div>
                        <button
                          type="button"
                          className={boardCls.deleteBetButtonCls}
                          onClick={() => handleDeleteBet(index)}
                          title="Eliminar apuesta"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                    <div className={boardCls.summaryRowCls}>
                      <div className={boardCls.summaryCellCls}>
                        <strong>Total</strong>
                      </div>
                      <div className={boardCls.summaryCellCls}>-</div>
                      <div className={boardCls.summaryCellCls}>
                        <strong>{ticketBets.reduce((sum, bet) => sum + bet.amount, 0)}</strong>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Confirm Ticket Purchase Modal */}
      <ConfirmTicketModal
        visible={isConfirmModalVisible}
        onClose={handleCloseConfirmModal}
        onCloseKeepBets={handleCloseModalKeepBets}
        placedBets={ticketBets.map(bet => ({
          drawName: bet.drawName,
          animalId: bet.number,
          animalName: bet.number,
          fichas: [{id: `${bet.drawId}-${bet.number}`, value: bet.amount, name: `${bet.amount} Bs`}],
        }))}
        totalAmount={ticketBets.reduce((sum, bet) => sum + bet.amount, 0)}
        selectedTime={selectedHours.length > 0 ? selectedHours.join(", ") : ""}
        onConfirmPurchase={handleConfirmPurchase}
        isPending={isPending}
        isSuccess={isSuccess}
        onRemoveBet={handleDeleteBet}
        isError={isError}
        gameType={"numbers"}
        gameName={gameName}
      />
    </div>
  );
};

TerminalBoard.propTypes = {
  gameName: PropTypes.string,
  placedBets: PropTypes.arrayOf(
    PropTypes.shape({
      animalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      animalName: PropTypes.string,
      fichas: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.number,
          name: PropTypes.string,
        })
      ),
    })
  ),
  draws: PropTypes.arrayOf(PropTypes.object),
};

export default TerminalBoard;
